import request from '@/utils/request'

const apis = {
    COURSE_INFO: '/course/getcourse',
    EXAM_INFO: '/course/getexamination',
    START_EXAM: '/course/startexamination',
    QUESTION_LIST: '/course/getquestionlist',
    SUBMIT: '/course/finishexamination',
    COMPARE_FACE_RETURNFILE: '/remoteapi/comparefaceReturnFile',
    COMPARE_FACE_RETURNFILES: '/remoteapi/saveFileReturnFile',
    REAL_EXAM_COMPARE_FACE_RETURNFILE: '/remoteapi/realExamComparefaceReturnFile',
    SAVE_COMPARE_FILE: '/remoteapi/saveExamCompareFile',
    SAVE_COMPARE_FILE_REDIS: '/remoteapi/saveExamCompareFileToRedis',
    GET_EXAMSUPERVISIONRULES_BYLOGINUSER: '/lesson/onlineLessonStudySupervised/getExamSupervisionRulesByLoginUser',
    COMPARE_FACE: '/remoteapi/compareface',
    TAKE_PICTRUE:'/remoteapi/pccompareface',
    GET_TESTINFO:'course/getTestInfo',
    SET_TESTID:'/course/setTestId',
    GETDENGDAIKAOSHIZHONGINFO:'/course/getDengDaiKaoShiZhongInfo',
    IS_CHECK_EXAM_LIMIT_ENDTIME : '/course/isCheckExamLimitEndTime',
}

export default {
    //上传照片
    photos(data) {
        let dt = data || {};
        return request.post(apis.TAKE_PICTRUE, dt.params, {
            headers: dt.headers || {}
        });
    },
// 信息列表
    getExamSupervisionRulesByLoginUser(data) {
        let dt = data || {};
        return request.post(apis.GET_EXAMSUPERVISIONRULES_BYLOGINUSER, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 信息列表
    saveExamCompareFile(data) {
        let dt = data || {};
        return request.post(apis.SAVE_COMPARE_FILE, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 信息列表
    saveExamCompareFileRedis(data) {
        let dt = data || {};
        return request.post(apis.SAVE_COMPARE_FILE_REDIS, dt.params, {
            headers: dt.headers || {}
        });
    },
    // 信息列表
    getCourseInfo(data) {
        let dt = data || {};
        return request.post(apis.COURSE_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },

    getIsCheckExamLimitEndTime(data) {
        let dt = data || {};
        return request.post(apis.IS_CHECK_EXAM_LIMIT_ENDTIME, dt.params, {
            headers: dt.headers || {}
        });
    },

    getExamInfo(data) {
        let dt = data || {};
        return request.post(apis.EXAM_INFO, dt.params, {
            headers: dt.headers || {}
        });
    },

    startExam(data) {
        let dt = data || {};
        return request.post(apis.START_EXAM, dt.params, {
            headers: dt.headers || {}
        });
    },

    getQuestionList(data) {
        let dt = data || {};
        return request.post(apis.QUESTION_LIST, dt.params, {
            headers: dt.headers || {}
        });
    },

    submit(data) {
        let dt = data || {};
        return request.post(apis.SUBMIT, dt.params, {
            headers: dt.headers || {}
        });
    },

    compareFace(data) {
        let dt = data || {};
        let params = dt.params || {};
        let formData = new FormData();
        for (let k in params) {
            if (k && params[k] != null) {
                formData.append(k + '', params[k]);
            }
        }

        return request.post(apis.COMPARE_FACE, formData, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, dt.headers)
        });
    },
  comparefaceReturnFile(data) {
    let dt = data || {};
    let params = dt.params || {};
    let formData = new FormData();
    for (let k in params) {
      if (k && params[k] != null) {
        formData.append(k + '', params[k]);
      }
    }
    return request.post(apis.COMPARE_FACE_RETURNFILE, formData, {
      headers: Object.assign({
        'Content-Type': 'multipart/form-data'
      }, dt.headers)
    });
  },
    realExamcomparefaceReturnFile(data) {
        let dt = data || {};
        let params = dt.params || {};
        let formData = new FormData();
        for (let k in params) {
            if (k && params[k] != null) {
                formData.append(k + '', params[k]);
            }
        }
        return request.post(apis.REAL_EXAM_COMPARE_FACE_RETURNFILE, formData, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, dt.headers)
        });
    },
    saveFileReturnFile(data) {
        let dt = data || {};
        let params = dt.params || {};
        let formData = new FormData();
        for (let k in params) {
            if (k && params[k] != null) {
                formData.append(k + '', params[k]);
            }
        }
        return request.post(apis.COMPARE_FACE_RETURNFILES, formData, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, dt.headers)
        });
    },
    getTestInfo(data){
        let dt = data || {};
        return request.post(apis.GET_TESTINFO, dt.params, {
            headers: dt.headers || {}
        });
    },
    setTestId(data){
        let dt = data || {};
        return request.post(apis.SET_TESTID, dt.params, {
            headers: dt.headers || {}
        });
    },
    getDengDaiKaoShiZhongInfo(data){
        let dt = data || {};
        return request.post(apis.GETDENGDAIKAOSHIZHONGINFO, dt.params, {
            headers: dt.headers || {}
        });
    }

}




// WEBPACK FOOTER //
// ./src/api/exam.js